import httpService from "services/httpService";

const baseApiEndPoint = process.env.REACT_APP_API_ENDPOINT;

const apiEndPoint = baseApiEndPoint + "/delivery_update";

export async function addToBatch(shipmentId, batchId) {
    const {data} = await httpService.post(apiEndPoint + "/add_to_batch", {
        shipmentId,
        batchId
    });
    return data;
}

export async function updateBatchTrackingInfo(batchId, statusId, currentLocationCountryCode) {
    const {data} = await httpService.post(apiEndPoint + "/update_batch_tracking_info", {
        batchId,
        statusId,
        currentLocationCountryCode
    });
    return data;
}

export default {
    addToBatch,
    updateBatchTrackingInfo
};
